var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { actions: _vm.pageActions, page: _vm.page }
      }),
      _c("validation-observer", { ref: "csseFormValidator" }, [
        !_vm.inEditMode && _vm.canShowCSEEOfficialQuestion
          ? _c(
              "div",
              { staticClass: "mb-3" },
              [
                _c(
                  "ordered-header-card",
                  {
                    staticClass: "manage-specialist",
                    attrs: { "is-ordered": false }
                  },
                  [
                    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                      _c("div", { staticClass: "row mb-2" }, [
                        _c("div", { staticClass: "col-12 mb-2" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 custom-control-inline" },
                              [
                                _c("label", { staticClass: "mr-2" }, [
                                  _vm._v(
                                    " ¿Está añadiendo un funcionario de CSEE para la coordinación de citas en localidades servicio al cliente? "
                                  )
                                ])
                              ]
                            )
                          ])
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      { attrs: { slot: "actions" }, slot: "actions" },
                      [
                        _c("validation-provider", {
                          attrs: { name: "CSSEOfficial", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-radio", {
                                      staticClass:
                                        "manage-specialist__custom-radio",
                                      attrs: {
                                        id: "rbtn-CSSEOfficial",
                                        "change-event":
                                          _vm.onChangeCSSEEOfficialAnswer,
                                        "custom-error-msg":
                                          "Debe seleccionar una opción",
                                        "custom-style": {
                                          separator: "0px",
                                          radioButtonWidth: "85px",
                                          centerBorderRadius: true
                                        },
                                        error: errors[0],
                                        "is-question-list": "",
                                        name: "CSSEOfficialQuestions",
                                        options: _vm.csseOfficialOptions,
                                        type: "questions"
                                      },
                                      model: {
                                        value: _vm.selectedCSEEOfficialAnswer,
                                        callback: function($$v) {
                                          _vm.selectedCSEEOfficialAnswer = $$v
                                        },
                                        expression: "selectedCSEEOfficialAnswer"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            968327401
                          )
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      !_vm.inEditMode &&
      (_vm.selectedCSEEOfficialAnswer == null || !_vm.isCreatingCSEEOficial)
        ? _c("ssn-search", {
            attrs: { "csse-form-validator": this.csseFormValidator() },
            on: {
              "on-create": _vm.setActions,
              "on-specialist-added": _vm.specialistAdded,
              "on-specialist-found": _vm.specialistFound
            }
          })
        : _vm._e(),
      !_vm.inEditMode && _vm.isCreatingCSEEOficial
        ? _c("user-search", {
            attrs: { "csse-form-validator": this.csseFormValidator() },
            on: {
              "on-create": _vm.setActions,
              "on-specialist-added": _vm.specialistAdded,
              "on-specialist-found": _vm.specialistFound
            }
          })
        : _vm._e(),
      _vm.inEditMode
        ? _c("board", { staticClass: "mb-4", attrs: { details: _vm.board } })
        : _vm._e(),
      _vm.inEditMode
        ? _c(
            "b-tabs",
            {
              attrs: {
                "content-class": "mt-3",
                "nav-class": "mipe-orange-tabs",
                "no-nav-style": ""
              }
            },
            [
              _c(
                "b-tab",
                { attrs: { active: "", title: "Información de Especialista" } },
                [
                  _c("specialist", {
                    ref: "specTab",
                    attrs: {
                      disabled: _vm.isReadOnly,
                      "exemption-files": _vm.exemptionFiles,
                      "immediate-save": _vm.inImmediateSaveMode,
                      "is-exemption-param-enabled": _vm.isExemptionParamEnabled,
                      "is-exemption-required": _vm.isExemptionRequired
                    },
                    on: {
                      "on-specialist-change": _vm.specialistChange,
                      "on-specialist-created": _vm.specialistCreated
                    },
                    model: {
                      value: _vm.specialistData,
                      callback: function($$v) {
                        _vm.specialistData = $$v
                      },
                      expression: "specialistData"
                    }
                  })
                ],
                1
              ),
              _vm.showSupervisionTab
                ? _c(
                    "b-tab",
                    { attrs: { title: "Información de Supervisión" } },
                    [
                      _c("supervision", { attrs: { disabled: _vm.isReadOnly } })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showDispenseTab
                ? _c(
                    "b-tab",
                    { attrs: { title: "Dispensas" } },
                    [
                      _c("dispensations-component", {
                        attrs: {
                          "company-id": _vm.companyId,
                          disabled: _vm.isReadOnly,
                          "external-model": _vm.dispensations,
                          "is-d-e-p-r": _vm.isDEPR,
                          "specialist-id": _vm.specialistId
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }